import React from 'react';

import { ErrorMessage } from '@atlaskit/form';

import { Header } from '@qality/common-components/src/atoms/Header';
import { Link } from '@qality/common-components/src/atoms/Link';
import { Sup } from '@qality/common-components/src/atoms/Sup';
import SectionMessage from '@qality/common-components/src/atoms/atlaskit/SectionMessage';
import { downloadExampleCSV } from '@qality/common-components/src/molecules/ImportTestCasesForm/utils';
import AttributeMapperField from '@qality/common-components/src/molecules/final-form/AttributeMapperField';

import {
  FieldMapperMessageBoxStyled,
  FieldMapperStyled,
  FieldNameStyled,
} from './FieldMapper.styled';

export const FieldMapperView = ({
  hasError,
  options,
  missingFields,
  mandatorySelectionFields,
  emptyMapping,
}: any) => {
  const getRequiredFieldNames = (fieldNames) =>
    fieldNames?.map((fieldName, idx, arr) => (
      <React.Fragment key={fieldName}>
        <FieldNameStyled>
          {fieldName}
          <Sup>*</Sup>
        </FieldNameStyled>
        {idx < arr.length - 1 ? ', ' : null}
      </React.Fragment>
    ));

  return (
    <FieldMapperStyled>
      <Header spacing='medium'>Map fields</Header>
      <p>
        Define how the fields from uploaded CSV files will map onto Jira issue
        fields.
      </p>
      <FieldMapperMessageBoxStyled>
        {hasError ? (
          <SectionMessage title='Required fields missing' appearance='error'>
            <span>
              To continue mapping, please select required Jira issue fields:{' '}
              {getRequiredFieldNames(missingFields)}
            </span>
          </SectionMessage>
        ) : (
          <SectionMessage appearance='warning'>
            <span>
              In the chosen project some Jira issue fields are required.
              Remember to select them in the mapping
              <br />
              Required issue fields:{' '}
              {getRequiredFieldNames(mandatorySelectionFields)}
            </span>
          </SectionMessage>
        )}
      </FieldMapperMessageBoxStyled>
      <AttributeMapperField name='mapping' options={options} />
      {hasError && <ErrorMessage>Required fields missing</ErrorMessage>}
      {emptyMapping && (
        <SectionMessage appearance='error'>
          <span>
            We haven’t found any fields in the provided CSV file. Please check
            it or upload a different CSV file.
            <br />
            You can also
            <Link onClick={downloadExampleCSV}> Download CSV template </Link>
            to verify your file’s compliance.
          </span>
        </SectionMessage>
      )}
    </FieldMapperStyled>
  );
};
